module.exports = __webpack_public_path__ + "static/media/financial-stress-and-thinking-large.b54f1421.png";